import { render, staticRenderFns } from "./RoleDesktopTopNav.vue?vue&type=template&id=482c027a&scoped=true"
import script from "./RoleDesktopTopNav.vue?vue&type=script&lang=js"
export * from "./RoleDesktopTopNav.vue?vue&type=script&lang=js"
import style0 from "./RoleDesktopTopNav.vue?vue&type=style&index=0&id=482c027a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c027a",
  null
  
)

export default component.exports